// เปิด/ปิด feature ตาม env (REACT_APP_ENV) ผูกไว้ในโค้ดแทน .env
// เพราะ .env ของแต่ละ branch ต่างกันทั้งไฟล์ ถ้าเพิ่มบรรทัดใน .env ตอน merge dev -> qas -> prd จะ conflict หรือพาค่าของ dev ติดขึ้นไป
// จะเปิดบน prd: เปลี่ยน PRD เป็น true แล้ว deploy ใหม่
// env ที่ไม่รู้จัก (หรือไม่ได้ตั้ง REACT_APP_ENV) ถือว่าปิด
type Env = 'DEV' | 'QAS' | 'PRD'

export type FeatureFlag =
  // เหตุผลการ Set Up: ช่องเลือก Group/Code ใน WorkCenterForm, code ในตาราง log, คอลัมน์ Type แบบ "code - description"
  | 'SETUP_REASON_CODE'

const FeatureFlags: Record<FeatureFlag, Record<Env, boolean>> = {
  SETUP_REASON_CODE: { DEV: true, QAS: true, PRD: false },
}

export const isFeatureEnabled = (flag: FeatureFlag): boolean => {
  const env = process.env.REACT_APP_ENV as Env | undefined
  return env ? FeatureFlags[flag][env] === true : false
}
